<template>
  <div data-cy="portal-sidenav-dropdown"
    v-if="!!userProfile"
    class="profile-dropdown"
    :class="{ 'tenant-layout': isTenantInstance }"
    @mouseenter="setDropdown(true)"
    @mouseleave="delayedClose"
    @click="setDropdown(true)"
    v-click-outside="() => setDropdown(false)">
    <div class="position-relative" :class="{ 'border-bottom': hasBorder }">
      <div class="portal-username">
        <div data-cy="portal-sidenav-username" class="d-none d-lg-flex profile-link align-items-center px-4 py-2">
          <div class="d-flex align-items-center justify-content-center">
            <font-awesome-icon :icon="faCircleUser"></font-awesome-icon>
          </div>
          <span ref="displayNameText" data-cy="username" class="username text-capitalize text-truncate ms-2">{{ displayName }}</span>
        </div>
      </div>
      <NavMenu v-show="dropdownVisible"
        :hideAppLinks="true"
        ref="submenu"
        :position="{
          position: 'fixed',
          bottom: dropdownBottom,
          left: dropdownLeft,
        }"
        @close="setDropdown(false)"/>
    </div>
  </div>
</template>

<script>
import { faCircleUser } from '@fortawesome/pro-regular-svg-icons'
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useBorrowerStore } from '~/store/borrower'
import { usePortalStore } from '~/store/portal'
import { useRootStore } from '~/store/root'
import formatImagePath from '~/libs/image-format'
import { get } from 'es-toolkit/compat'
import NavMenu from '~/components/NavMenu.vue'

export default {
  name: 'SidenavProfileDropdown',
  components: {
    NavMenu,
  },
  props: {
    hasBorder: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { formatImagePath, faCircleUser }
  },
  data () {
    return {
      dropdownVisible: false,
      dropdownLeft: '0px',
      dropdownBottom: '20px',
    }
  },
  computed: {
    ...mapState(useRootStore, ['userProfile']),
    ...mapState(usePortalStore, ['navLinks']),
    ...mapState(useBorrowerStore, {
      borrowerName: store => get(store, 'borrower.name'),
    }),
    ...mapState(useAffiliateCustomizationStore, ['isEmbeddedLayout']),
    isTenantInstance() {
      return this.isEmbeddedLayout
    },
    displayName () {
      if (this.borrowerName) {
        return this.borrowerName
      }

      if (this.userProfile && this.userProfile.first && this.userProfile.last) {
        const fullLength = this.userProfile.first.length + this.userProfile.last.length + 1

        if (fullLength <= 16) {
          return this.userProfile.first + ' ' + this.userProfile.last
        }

        return this.userProfile.first
      }
      return ''
    },
  },
  methods: {
    setDropdown (val) {
      clearTimeout(this._closeTimer)
      this.dropdownVisible = val

      if (val) {
        this.$nextTick(() => {
          this.updateDropdownPosition()
        })
      }
    },
    delayedClose () {
      this._closeTimer = setTimeout(() => {
        this.dropdownVisible = false
      }, 150)
    },
    updateDropdownPosition() {
      const displayNameEl = this.$refs.displayNameText
      const containerEl = this.$el

      if (!displayNameEl || !containerEl) {
        return
      }

      const displayNameRect = displayNameEl.getBoundingClientRect()
      const containerRect = containerEl.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      this.dropdownLeft = `${displayNameRect.right + 25}px`
      this.dropdownBottom = `${Math.max(20, viewportHeight - containerRect.bottom)}px`
    },
  },
  watch: {
    '$route.path' () {
      this.dropdownVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.profile-dropdown {
  padding: 0 8px;
  position: relative;
  .portal-username {
    padding: 16px 8px;
    font-size: 16px;
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
  }
  > .border-bottom {
    border-bottom: 1px solid $background-100;
  }
  .profile-link {
    padding: 8px 16px;
    border-radius: 8px;
    color: $background-100;
    font-size: 16px;
    cursor: pointer;
  }
  &.tenant-layout {
    > .border-bottom {
      border-color: $app-nav-text-primary;
    }
    .profile-link {
      color: $app-nav-text-primary;
    }
  }
}
.username {
  text-transform: uppercase;
  letter-spacing: .5px;
}
</style>
